import React from 'react';
import { Box, Typography, Grid, TextField } from '@mui/material';
import { Client } from '../../types/client';

interface TradingDurationSectionProps {
  client: Client;
  tradingYears: string;
  setTradingYears: (value: string) => void;
  tradingMonths: string;
  setTradingMonths: (value: string) => void;
  calculateShowAdditionalInfo: (years: string, months: string) => boolean;
  sectionStyle: any;
}

const TradingDurationSection: React.FC<TradingDurationSectionProps> = ({
  client,
  tradingYears,
  setTradingYears,
  tradingMonths,
  setTradingMonths,
  calculateShowAdditionalInfo,
  sectionStyle
}) => {
  // Only show for Sole Traders without trading duration
  if (client.businessType !== 'Sole Trader' || client.yearsTrading !== undefined) {
    return null;
  }

  return (
    <Box mb={4} sx={sectionStyle}>
      <Typography variant="h6" gutterBottom color="primary">
        Trading Duration
      </Typography>
      <Typography variant="body2" color="textSecondary" mb={2}>
        Please provide how long you have been trading for:
      </Typography>
      <Grid container spacing={3}>
        <Grid item xs={12} md={3}>
          <TextField
            fullWidth
            label="Years"
            type="number"
            value={tradingYears}
            onChange={(e) => {
              setTradingYears(e.target.value);
              calculateShowAdditionalInfo(e.target.value, tradingMonths);
            }}
            InputProps={{ inputProps: { min: 0, max: 99 } }}
          />
        </Grid>
        <Grid item xs={12} md={3}>
          <TextField
            fullWidth
            label="Months"
            type="number"
            value={tradingMonths}
            onChange={(e) => {
              setTradingMonths(e.target.value);
              calculateShowAdditionalInfo(tradingYears, e.target.value);
            }}
            InputProps={{ inputProps: { min: 0, max: 11 } }}
          />
        </Grid>
      </Grid>
    </Box>
  );
};

export default TradingDurationSection;
